import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  DashboardDetails,
  NotificationDetails,
  PODNotification,
} from "../../../../../API/Bank/Dashboard";
import cookies from "../../../../../CommonFunction/cookies";
import Loader from "../../../../../CommonFunction/Loader";
import LoanAccounts from "./Tabs/LoanAccounts";
import DefaultLoanAccount from "./Tabs/DefaultLoanAccount";
import NPALoans from "./Tabs/NPALoans";
import KYCDefault from "./Tabs/KYCDefault";
import DeliveryDefault from "./Tabs/DeliveryDefault";
import { UserContext } from "../../../../../App";
import { DashboardLoading } from "../../Elements/ServeLoading";
import {
  formatDate,
  formatDate2,
} from "../../../../../CommonFunction/FormatedDate";
import BankNotificationModal from "./BankNotificationModal";

const BankDashboard = () => {
  const observer = useRef();
  const hasMoreRef = useRef(true);
  const [value, onChange] = useState(new Date());
  const [dashboardData, setDashboardData] = useState([]);
  const [noticeMsg, setNoticeMsg] = useState([]);
  const [podMsg, setPodMsg] = useState([]);
  const [openSelector, setOpenSelector] = useState(false);
  const [page, setPage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const jwtToken = cookies.get("jwt");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [msgType, setMsgType] = useState("notice");
  const decodedData = useContext(UserContext);
  const [loadingMore, setLoadingMore] = useState(false);
  const bankID = decodedData?.bank;
  const branchID = decodedData?.branch;
  const role = decodedData?.role;
  const [messageOpen, setMessageOpen] = useState(false);
  const [messageById, setMessageById] = useState([]);

  const dateQuery = (dateStr) => {
    const date = new Date(dateStr);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    console.log("formatted date is -", formattedDate);
    return formattedDate;
  };

  const fetchDashboardDetails = async () => {
    setLoading(true);
    try {
      const data = await DashboardDetails(jwtToken, bankID, branchID, role);
      setDashboardData(data?.counts);
    } catch (error) {
      console.error("Error retrieving organization data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchNoticeMsg = async () => {
    setError("");
    setNoticeMsg([]);
    setIsLoading(true);
    try {
      const data = await NotificationDetails(
        jwtToken,
        bankID,
        branchID,
        role,
        dateQuery(value)
      );
      if (data?.code === 200) {
        setNoticeMsg(data?.response?.data?.response);
      } else {
        setError(
          "No Notification Found. Select other dates for previous notification."
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error retrieving organization data:", error);
    }
  };

  const fetchPODMsg = async () => {
    setError("");
    setNoticeMsg([]);
    setIsLoading(true);
    try {
      const data = await PODNotification(jwtToken, dateQuery(value));
      if (data?.code === 400) {
        setError(
          "No POD Notification Found. Select other dates for previous notification."
        );
      } else {
        setPodMsg(data?.docs);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error retrieving organization data:", error);
    }
  };

  const Buttons = [
    {
      type: "notice",
      label: "Notice",
    },
    {
      type: "pod",
      label: "POD",
    },
    {
      type: "kycDefault",
      label: "KYC Default",
    },
  ];

  useEffect(() => {
    if (bankID || branchID) {
      fetchDashboardDetails();
    }
  }, [bankID, branchID, role]);

  useEffect(() => {
    if (msgType === "notice") {
      fetchNoticeMsg();
    } else if (msgType === "pod") {
      fetchPODMsg();
    }
  }, [value, msgType]);

  const data = [
    {
      name: "Total Active Loan Accounts",
      loans: `${dashboardData?.totalActiveLoans || "0"}`,
      percent: "+3.48",
      page: "loans",
    },
    {
      name: "Loan Acc. with Default Reminders",
      loans: `${dashboardData?.overdueLoans || "0"}`,
      percent: "+3.48",
      page: "defaultLoans",
    },
    {
      name: "Loan Account in NPA",
      loans: `${dashboardData?.defaultNpa || "0"}`,
      percent: "+3.48",
      page: "npaLoans",
    },
    {
      name: "KYC Defaulters",
      loans: `${dashboardData?.kycDetail || "0"}`,
      percent: "+3.48",
      page: "kycAcc",
    },
    {
      name: "Delivery Default",
      loans: `${dashboardData?.deliveryDefaultNotice || "0"}`,
      percent: "+3.48",
      page: "deliveryDefaultLoan",
    },
  ];

  const openMessage = (item) => {
    setMessageOpen(true);
    console.log("Notification data is here === ", item);
    setMessageById(item);
  };

  const closeMessage = () => {
    setMessageOpen(false);
    setMessageById([]);
  };

  const lastMessageElementRef = useCallback(
    (node) => {
      if (loadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreRef.current) {
          console.log("Ye wala function chal rha h.");
          setLoadingMore(true);
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loadingMore] // Don't include `hasMore` to avoid retrigger
  );

  const openPage = (page) => {
    setOpenSelector(true);
    setPage(page);
  };

  const onClose = () => {
    setOpenSelector(false);
    setPage("");
  };

  return (
    <>
      <div className="root-style">
        <div className="mt-6 mb-20">
          {loading ? (
            <div>
              <Loader />
            </div>
          ) : (
            <div className="w-full">
              <div className="text-[24px] font-[600] my-5 text-bgclr6">
                <h1>Overview</h1>
              </div>
              <div className="grid lg:grid-cols-4 gap-5 lg:mr-3">
                {data.map((item, index) => (
                  <button
                    key={index}
                    className="bg-bgclr9 text-left pl-5 pr-1 h-[140px] mt-5 rounded-3xl shadow-xl"
                    onClick={() => openPage(item.page)}
                  >
                    <p className="text-[14px] text-[#A0AEC0]">{item.name}</p>
                    <h3 className="text-[18px] text-[#2D3748] font-[700]">
                      {item.loans}
                    </h3>
                    <div className="flex items-end mt-7">
                      <h2 className="text-[14px] text-[#48BB78] font-[700]">
                        {item.percent}
                      </h2>
                      <p className="text-[14px] text-[#A0AEC0] ml-3">
                        Since last month
                      </p>
                    </div>
                  </button>
                ))}
              </div>
              <div className="grid lg:grid-cols-2 mt-10 gap-5">
                <div className="rounded-xl bg-bgclr9 shadow-lg">
                  <div className="flex justify-between px-3 py-3 border-b">
                    <div className="lg:text-[24px] text-[20px] font-[600] text-bgclr6">
                      <h1>Notifications</h1>
                    </div>
                    <div className="flex lg:gap-4 gap-2 text-[12px] lg:text-[14px]">
                      {Buttons.map((item, index) => (
                        <div key={index} className="flex">
                          <button
                            onClick={() => setMsgType(item.type)}
                            className={`${msgType === item.type
                                ? "bg-bgclr text-[#fff]"
                                : "bg-pink-50"
                              } lg:px-3 px-2.5 rounded-md font-[500]`}
                          >
                            {item.label}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Notifications */}
                  <div className="h-[35vh] overflow-y-auto">
                    {isLoading ? (
                      <div className="flex justify-center items-center h-full">
                        <DashboardLoading />
                      </div>
                    ) : (
                      <div>
                        {error !== "" ? (
                          <div className="flex justify-center items-center px-5">
                            <h2 className="text-[16px] text-center font-semibold mt-24 text-gray-600">
                              {error}
                            </h2>
                          </div>
                        ) : (
                          <div>
                            {msgType === "notice" && (
                              <div>
                                {noticeMsg?.docs?.map((item, index) => {
                                  const isLastItem =
                                    index === noticeMsg.docs.length - 1;
                                  return (
                                    <button
                                      ref={
                                        isLastItem
                                          ? lastMessageElementRef
                                          : null
                                      }
                                      key={item._id}
                                      onClick={() => openMessage(item)}
                                      className={`pl-5 pr-1 text-left py-5 w-full border-b hover:bg-bgclr9 ${!item.read
                                          ? "bg-slate-200"
                                          : "bg-bgclr9"
                                        }`}
                                    >
                                      <div className="flex justify-between">
                                        <h2 className="text-[18px] text-bgclr font-bold">
                                          Action Required:{" "}
                                          <span className="text-gray-700 font-[600]">
                                            Serve{" "}
                                            {item?.nextNoticeServe?.join(", ")}{" "}
                                            notice
                                          </span>
                                        </h2>
                                        <p className="text-[14px] text-[#A0AEC0] mx-3">
                                          {formatDate2(item?.dueDate)}
                                        </p>
                                      </div>
                                      <p className="text-[16px] text-gray-600">
                                        It's been <b>{item?.totalDayCount}</b>{" "}
                                        days since the{" "}
                                        <b>{item?.lastStatusType}</b> notice was
                                        served for Loan Account No.{" "}
                                        <b>{item?.identity_number}</b>. As per
                                        the compliance timeline.....
                                        {/* , it's now time to
                                      serve the B2/B3 notice due to continued
                                      EMI default. */}
                                      </p>
                                    </button>
                                  );
                                })}
                              </div>
                            )}
                            {msgType === "pod" && (
                              <div>
                                {podMsg?.map((item, index) => {
                                  const isLastItem =
                                    index === podMsg?.length - 1;
                                  return (
                                    <button
                                      ref={
                                        isLastItem
                                          ? lastMessageElementRef
                                          : null
                                      }
                                      key={item._id}
                                      onClick={() => openMessage(item)}
                                      className={`pl-5 pr-1 text-left py-5 w-full border-b hover:bg-bgclr9 ${!item.read
                                          ? "bg-slate-200"
                                          : "bg-bgclr9"
                                        }`}
                                    >
                                      <div className="flex justify-between">
                                        <h2 className="text-[18px] text-bgclr font-[700]">
                                          {item?.bank?.name}
                                        </h2>
                                        <p className="text-[14px] text-[#A0AEC0]">
                                          {formatDate(item?.created_at)}
                                        </p>
                                      </div>
                                      <p className="text-[16px] text-gray-600">
                                        Proof of Delivery has been generated for
                                        Notice <b>{item?.notices[0]?.type}</b>{" "}
                                        related to Loan Account No.{" "}
                                        <b>{item?.loan?.identity_number}</b>.
                                        You can now...
                                      </p>
                                    </button>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="rounded-xl bg-bgclr9 shadow-lg">
                  <div>
                    <div className="text-[24px] px-3 font-[600] py-3 text-bgclr6">
                      <h1>Calender</h1>
                    </div>
                    <div className="flex justify-center text-black">
                      <Calendar
                        onChange={onChange}
                        maxDate={new Date()}
                        value={value}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="hidden md:bolck mt-10 bg-bgclr9 p-5 rounded-xl border">
                <div className="mb-3">
                  <h2 className="text-[24px] font-[500] ">User Statistics</h2>
                </div>
                {/* <div>
                  <ColumnChart />
                </div> */}
              </div>
            </div>
          )}
        </div>
      </div>

      {openSelector && (
        <>
          {page === "loans" && (
            <LoanAccounts
              onClose={onClose}
              isOpen={openSelector}
              bankID={bankID}
              branchID={branchID}
              role={role}
            />
          )}
          {page === "defaultLoans" && (
            <DefaultLoanAccount
              onClose={onClose}
              isOpen={openSelector}
              bankID={bankID}
              branchID={branchID}
              role={role}
            />
          )}
          {page === "npaLoans" && (
            <NPALoans
              onClose={onClose}
              isOpen={openSelector}
              bankID={bankID}
              branchID={branchID}
              role={role}
            />
          )}
          {page === "kycAcc" && (
            <KYCDefault
              onClose={onClose}
              isOpen={openSelector}
              bankID={bankID}
              branchID={branchID}
              role={role}
            />
          )}
          {page === "deliveryDefaultLoan" && (
            <DeliveryDefault
              onClose={onClose}
              isOpen={openSelector}
              bankID={bankID}
              branchID={branchID}
              role={role}
            />
          )}
        </>
      )}

      {messageOpen && (
        <BankNotificationModal
          data={messageById}
          messageOpen={messageOpen}
          closeMessage={closeMessage}
          msgType={msgType}
        />
      )}
    </>
  );
};

export default BankDashboard;
